import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// api
import { getTextTermsUse } from 'api/company';
// images
import Condiciones from 'assets/img/img_condiciones.png';
// components
import Head from 'components/metatags_helmet/metatags';
import NoResults from 'components/userzone/NoResults';
import './infoPages.scss';

const TermsOfUse = () => {
  const [termsOfUse, setTermsOfUse] = useState({});
  const { t, i18n } = useTranslation(['footer']);
  const title = t('usageconditions');

  const getTermsOfUse = async () => {
    const { status, data } = await getTextTermsUse();
    if (status === 200) {
      setTermsOfUse(data[0]);
    }
  };

  useEffect(() => {
    getTermsOfUse();
  }, []);
  return (
    <div className="container-fluid mainDiv">
      <Head title={title} noIndex={true} />
      {termsOfUse && Object.keys(termsOfUse).length ? (
        <Row className="justify-content-center mainRow infoRow">
          <Col lg={8} className="mt-4">
            <div className="row">
              <div className="col-md-12">
                <h1 className="infoTitle">{termsOfUse[`title_${i18n.language}`] || termsOfUse.title}</h1>
                <hr />
              </div>
            </div>
            <div className="row">
              <div
                className="col-md-12"
                id="static-content"
                dangerouslySetInnerHTML={{
                  __html: termsOfUse[`text_${i18n.language}`] || termsOfUse.text,
                }}
              ></div>
            </div>
          </Col>
          <Col lg={3} className="d-flex justify-content-center align-items-start mt-4 pr-0 pt-lg-4">
            <img src={Condiciones} alt="paper.png" className="infoImg" />
          </Col>
        </Row>
      ) : (
        <NoResults className="noFavorites" />
      )}
    </div>
  );
};

export default TermsOfUse;
